import React, { useState } from 'react';
import { MaterialTextField } from '@/shared/components/form/MaterialFormElements';
import { EyeOutlineIcon, EyeOffOutlineIcon } from '@/shared/dynamicImports';
import styled from 'styled-components';
import { colorText } from '@/utils/palette';

const PasswordField = ({ name, label, defaultValue, placeholder, variant, error, onChange, helperText }) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <MaterialFieldContainer>
      <MaterialTextField
        name={name}
        variant={variant || 'standard'}
        type={showPassword ? 'text' : 'password'}
        label={label || 'Password'}
        placeholder={placeholder || 'Enter the password here...'}
        helperText={error}
        error={error}
        defaultValue={defaultValue}
        onChange={onChange}
      />
      <div style={{ marginTop: '15px', height: '27px' }}>
        {showPassword ? (
          <EyeOffOutlineIcon onClick={togglePasswordVisibility} />
        ) : (
          <EyeOutlineIcon onClick={togglePasswordVisibility} />
        )}
      </div>
      {helperText && <HelperText>{helperText}</HelperText>}
    </MaterialFieldContainer>
  );
};

export default PasswordField;

const HelperText = styled.div`
  font-size: 12px;
  margin-top: 5px;
  color: ${colorText};
`;

export const MaterialFieldContainer = styled.div`
  label {
    font-size: 12px;
    color: ${colorText};

    &[data-shrink='true'] {
      transform: translate(0, 1.5px) scale(0.85);
    }
  }

  span {
    color: ${colorText};
  }
  display: flex;
`;
